import React from "react";

const Visa = () => (
  <svg width="35" height="25" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 4h35v17H0z" />
      <path fill="#191E70" d="M4 0h27a4 4 0 014 4H0a4 4 0 014-4z" />
      <path fill="#F7B600" d="M0 21h35a4 4 0 01-4 4H4a4 4 0 01-4-4z" />
      <path
        fill="#191E70"
        fillRule="nonzero"
        d="M16.86 8.22l-2.02 9.7h-2.46l2.02-9.7h2.46zm10.16 6.27l1.3-3.66.72 3.66h-2.02zm2.74 3.43H32l-1.95-9.7h-2.09c-.43 0-.86.3-1 .75l-3.61 8.95h2.52l.5-1.42h3.1l.3 1.42zm-6.34-3.2c0-2.54-3.4-2.7-3.4-3.81.08-.52.51-.82 1.02-.82a4.4 4.4 0 012.38.45l.43-2.1A5.97 5.97 0 0021.62 8c-2.38 0-4.12 1.34-4.12 3.2 0 1.43 1.23 2.17 2.1 2.62.93.45 1.3.75 1.22 1.2 0 .66-.72.96-1.44.96-.87 0-1.73-.22-2.52-.6l-.44 2.1c.87.37 1.8.52 2.67.52 2.67.07 4.33-1.27 4.33-3.29zm-10.03-6.5l-3.89 9.7H6.9l-1.94-7.76c0-.37-.3-.67-.58-.82A8.21 8.21 0 002 8.52l.07-.3h4.11c.58 0 1.01.45 1.08.97l1.01 5.6 2.6-6.57h2.52z"
      />
    </g>
  </svg>
);

export default Visa;
